import { IAuthAction, eAuthAcitonTypes } from "../../action-types/auth/IAuthActions";
import { IAuthReducer, eAccountReducerStatus } from "../../reducer-model/auth/IAuthReducer";
const iniState: IAuthReducer = {

}
export const authReducer = (state: IAuthReducer = iniState, action: IAuthAction): IAuthReducer => {
    switch (action.type) {
        case eAuthAcitonTypes.GET_USER_START:
            return {
                ...state,
                status: eAccountReducerStatus.is_getting_profile
            }
        case eAuthAcitonTypes.GET_USER_SUCCESS:
            return {
                ...state,
                status: eAccountReducerStatus.is_get_profile_done,
                user: action.payload
            }
        case eAuthAcitonTypes.GET_USER_ERROR:
            return {
                ...state,
                status: eAccountReducerStatus.is_get_profile_done,
                user: undefined
            }
        case eAuthAcitonTypes.LOGIN_START:
            return {
                ...state,
                status: eAccountReducerStatus.is_logging_in
            }
        case eAuthAcitonTypes.LOGIN_SUCCESS:
            return {
                ...state,
                status: eAccountReducerStatus.is_log_in_success,
                user: action.payload.profile,
            }
        case eAuthAcitonTypes.LOGIN_ERROR:
            return {
                ...state,
                status: eAccountReducerStatus.is_log_in_error,
                user: undefined
            }
        case eAuthAcitonTypes.LOGOUT_SUCCESS:
            localStorage.removeItem("access_token")
            localStorage.removeItem("refresh_token")
            return {
                ...state,
                user: undefined,
                ticket: undefined,
                isSignOuted:true
            }

        default:
            return {
                ...state
            }
    }
}